import { useCallback, useMemo, useRef, useState } from "react";
import { useAppDispatch } from "../../api/core/useAppDispatch";
import { focusTool } from "../../api/features/image-tools/actions";
import useMosaicEvent from "../events/useMosaicEvent";
import ViewerEvent from "../../api/core/ViewerEvent";
import { ImageToolEvent } from "../../api/features/image-tools/types";

export default function useImageZoom() {
  const [eventData, setEventData] = useState<ImageToolEvent | null>(null);
  const dispatch = useAppDispatch();
  const triggerIdRef = useRef("");

  const refocus = useCallback(() => {
    if (triggerIdRef.current) {
      dispatch(focusTool(triggerIdRef.current));
      triggerIdRef.current = "";
    }
  }, [dispatch]);

  const clear = useCallback(() => {
    setEventData(null);
  }, []);

  useMosaicEvent(
    ViewerEvent.IMAGE_TOOL_ZOOM,
    useCallback((evt) => {
      setEventData(evt);
      triggerIdRef.current = evt.triggerId;
    }, [])
  );

  return useMemo(
    () => ({
      clear,
      refocus,
      eventData,
    }),
    [clear, refocus, eventData]
  );
}
